import axios from "axios";
import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";
import settings from "utils/settings";
import filterTypes from "data/filter-types";

import { requestCommonFilters, requestCommonSearch } from "../../common/requests";
import {
  CHARGERS_ERROR,
  CHARGERS_LOADING,

  CHARGERS_FILTERS,
  CHARGERS_LIST,
  CHARGERS_CREATE,
  CHARGERS_DELETE,

  CHARGERS_ACTION_LOCK,
  CHARGERS_ACTION_UNLOCK,
  CHARGERS_ACTION_VOICE,
  CHARGERS_ACTION_OPEN_COVER,
  CHARGERS_ACTION_UPDATE_STATUS,
} from "./constants";

const chargerUrl = `${settings.chargerUrl}api/`;
const ENDPOINT = "admin/power-bank";

export const setLoading = (status) => ({
  type: CHARGERS_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  requestCommonFilters(ENDPOINT, chargerUrl)
    .then((response) => {
      dispatch({
        type: CHARGERS_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, chargerUrl)
    .then((response) => {
      dispatch({
        type: CHARGERS_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};

export const getQR = (id, callback) => {
  const criteria = [{
    fieldName: "id",
    fieldValue: id,
    searchOperation: filterTypes.EQUALS.value
  }];
  requestCommonSearch(ENDPOINT, 0, 1, "id,ASC", criteria, chargerUrl)
    .then((response) => {
      const chargerQR = response && response.content && response.content[0]
        ? response.content[0].qr
        : false;
      callback(chargerQR);
    })
    .catch(() => {
      callback(false);
    });
};

export const getItem = (id, callback) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, null, 1, null, [{
    fieldName: "id",
    fieldValue: id,
    searchOperation: filterTypes.EQUALS.value
  }], chargerUrl)
    .then(response => {
      const item = response && response.content && response.content[0]
        ? response.content[0]
        : {};
      callback(item);
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};

export const createItem = (item) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${chargerUrl}/${ENDPOINT}`, item)
    .then(() => {
      dispatch({
        type: CHARGERS_CREATE,
        payload: item
      });
      toast("Charger updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};

export const deleteItem = id => dispatch => {
  dispatch(setLoading(true));
  axios.delete(`${chargerUrl}${ENDPOINT}/${id}`, id)
    .then((response) => {
      dispatch({
        type: CHARGERS_DELETE,
        payload: id
      });
      toast(response.data.message, {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};

export const actionLock = (id, callback = false) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${chargerUrl}${ENDPOINT}/${id}/lock`)
    .then(() => {
      dispatch({
        type: CHARGERS_ACTION_LOCK,
        payload: id
      });
      if (callback) callback(id);
      toast("Charger locked successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};

export const actionUnLock = (id, callback = false) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${chargerUrl}${ENDPOINT}/${id}/unlock`)
    .then(() => {
      dispatch({
        type: CHARGERS_ACTION_UNLOCK,
        payload: id
      });
      if (callback) callback(id);
      toast("Charger unlocked successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};

export const actionVoice = (id, callback = false) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${chargerUrl}${ENDPOINT}/${id}/voice`)
    .then(() => {
      dispatch({
        type: CHARGERS_ACTION_VOICE,
        payload: id
      });
      if (callback) callback(id);
      toast("Charger voiced successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};

export const actionOpenBatteryCover = (id, callback = false) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${chargerUrl}${ENDPOINT}/${id}/open-battery-cover`)
    .then(() => {
      dispatch({
        type: CHARGERS_ACTION_OPEN_COVER,
        payload: id
      });
      if (callback) callback(id);
      toast("Charger batter cover opened successfully", {
        type: toast.TYPE.SUCCESS
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};

export const actionUpdateChargerStatus = (id, status) => dispatch => {
  dispatch(setLoading(true));
  axios.patch(`${chargerUrl}${ENDPOINT}/${id}/${status}`)
    .then(() => {
      dispatch({
        type: CHARGERS_ACTION_UPDATE_STATUS,
        payload: {
          id,
          status
        }
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, CHARGERS_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/chargers/main/actions.js